import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_3 = {
  key: 2,
  class: "mt-6"
}

import { useRoute } from "vue-router";

import TitleHeader from "@/components/TitleHeader.vue";
import OrdersTable from "@/components/tables/OrdersTable.vue";
import LicensesTable from "@/components/tables/LicensesTable.vue";
import SubscriptionsTable from "@/components/tables/SubscriptionsTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersList',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t(_unref(route).name),
      class: "mt-6"
    }, null, 8, ["title"]),
    (_unref(route).name === 'Orders')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(OrdersTable, { "show-filters": true })
        ]))
      : _createCommentVNode("", true),
    (_unref(route).name === 'Licences')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LicensesTable, { "show-filters": true })
        ]))
      : _createCommentVNode("", true),
    (_unref(route).name === 'Subscriptions')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SubscriptionsTable, { "show-filters": true })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})